const elements = {
  ro: {
    quizStartTitle: 'Nu ştii cu cine să votezi...',
    questionLabel: 'Întrebarea',
    ofLabel: 'din',
    back: 'Înapoi',
    reset: 'Resetează chestionarul',
    resultTitle: 'Rezultate:',
    start: 'Start',
    disclaimer: 'la Alegerile pentru Parlamentul Republicii Moldova din <strong>28 septembrie 2025</strong>? Te ajut. Dar să știi că acest chestionar nu poate înlocui o analiză atentă a programelor și valorilor ale candidaților. Decizia ta merită mai multă reflecție decât completarea unui quiz.',
    privacy: 'Toată interacțiunea și rezultatul sunt stocate doar la tine și nu sunt transmise nimănui.',
    survey: 'Cercetare'
  },
  ru: {
    quizStartTitle: 'Не знаешь, за кого голосовать...',
    questionLabel: 'Вопрос',
    ofLabel: 'из',
    back: 'Назад',
    reset: 'Сбросить результаты',
    resultTitle: 'Результаты:',
    start: 'Начать',
    disclaimer: 'на выборах в Парламент Республики Молдова <strong>28-го сентября 2025</strong>? Я помогу. Но имей в виду, что этот тест не может заменить внимательный анализ программ кандидатов. Твоё решение заслуживает большего размышления, чем просто прохождение теста.',
    privacy: 'Всё взаимодействие и результаты сохраняются только у тебя и не передаются никому.',
    survey: 'Исследование'
  }
}

const parties = {
  ro: {
    parties: {
      pas: "Partidul 'Acțiune și Solidaritate'",
      ppda: "Partidul 'Democrația Acasă'",
      cub: "Coaliția pentru Unitate și Bunăstare",
      nastase: "Andrei Năstase",
      alde: "Alianța Liberalilor și Democraților pentru Europa",
      stamate: "Olesea Stamate",
      psde: "Partidul Social Democrat European",
      pnm: "Partidul Național Moldovenesc",
      bep: "Blocul Electoral 'Patriotic al Socialiștilor, Comuniștilor, Inima și Viitorul Moldovei'",
      alternativa: "Blocul Electoral 'Alternativa'",
      mrm: "Mișcarea 'Respect Moldova'",
      impreuna: "Blocul Electoral 'Împreună'",
      loc: "Liga Orașelor și Comunelor",
      aur: "Alianța pentru Unirea Românilor",
      sanduta: "Victoria Sanduța",
      am: "Alianța 'Moldovenii'",
      bun: "Blocul 'Unirea Națiunii'",
      pl: "Partidul Liberal",
      ucsm: "Uniunea Creștin-Socială din Moldova",
      cretu: "Tatiana Crețu",
      pn: "Partidul Nostru"
    }
  },
  ru: {
    parties: {
      pas: "Партия «Действие и Солидарность»",
      ppda: "Партия «Демократия дома»",
      cub: "Коалиция за Единство и Благосостояние",
      nastase: "Андрей Нэстасе",
      alde: "Альянс Либералов и Демократов за Европу",
      stamate: "Олеся Стамате",
      psde: "Европейская Социал-Демократическая Партия",
      pnm: "Молдавская Национальная Партия",
      bep: "Избирательный блок «Патриотический блок Социалистов, Коммунистов, Сердце и Будущее Молдовы»",
      alternativa: "Избирательный блок «Альтернатива»",
      mrm: "Движение Респект Молдова»",
      impreuna: "Избирательный блок «Вместе»",
      loc: "Лига Городов и Общин",
      aur: "Альянс за Объединение Румын",
      sanduta: "Виктория Сандуца",
      am: "Альянс «Молдаване»",
      bun: "Блок «Объединение Нации»",
      pl: "Либеральная Партия",
      ucsm: "Христианско-социальный Союз Молдовы",
      cretu: "Татьяна Крецу",
      pn: "Наша Партия"
    }
  }
}

const options = {
  ro: {
    options: {
      1: 'Complet de acord',
      2: 'De acord',
      3: 'Neutru',
      4: 'Împotrivă',
      5: 'Categoric împotrivă'
    }
  },
  ru: {
    options: {
      1: 'Полностью согласен',
      2: 'Согласен',
      3: 'Нейтрально',
      4: 'Против',
      5: 'Категорически против'
    }
  }
}

const roQuestions = {
  ro: {
    questions: {
      1: { text: 'Republica Moldova trebuie să continue ferm procesul de aderare la Uniunea Europeană, indiferent de presiunile externe și costurile interne.' },
      2: { text: 'Statutul de neutralitate al Republicii Moldova trebuie păstrat și respectat cu strictețe, pentru a evita implicarea în conflicte geopolitice.' },
      3: { text: 'Consolidarea legăturilor economice, culturale și politice cu România, cu perspectiva unei posibile uniri, este un obiectiv strategic național.' },
      4: { text: 'Îmbunătățirea relațiilor cu Federația Rusă este esențială pentru a asigura stabilitate regională și avantaje economice, precum prețuri mai bune la energie.' },
      5: { text: 'În funcție de vectorul politicii externe ales, candidatul trebuie să se afle într-o bună relație cu partenerii respectivi și să fie susținut și acceptat de aceștia.' },
      6: { text: 'În funcție de vectorul politicii externe ales, candidatul trebuie să înțeleagă și să respecte valorile și angajamentele dictate de această direcție.' },
      7: { text: 'Reforma sistemului de justiție, inclusiv prin evaluarea externă (vetting) a judecătorilor și procurorilor, trebuie accelerată pentru a consolida statul de drept.' },
      8: { text: 'Lupta împotriva corupției mari, a finanțării ilegale a partidelor și a dezinformării trebuie să fie o prioritate absolută.' },
      9: { text: 'Statul trebuie să-și asume un rol mai activ în economie prin programe sociale masive, subvenții și asistență directă, chiar dacă aceasta înseamnă creșterea cheltuielilor publice.' },
      10: { text: 'Instituțiile statului ar trebui să aibă puteri sporite pentru a combate dezinformarea și activitățile subversive finanțate din exterior.' }
    }
  }
}

const ruQuestions = {
  ru: {
    questions: {
      1: { text: "Республика Молдова должна решительно продолжать процесс присоединения к Европейскому союзу, несмотря на внешнее давление и внутренние издержки." },
      2: { text: "Нейтральный статус Республики Молдова должен быть сохранён и строго соблюдаться, чтобы избежать вовлечения в геополитические конфликты." },
      3: { text: "Укрепление экономических, культурных и политических связей с Румынией, с перспективой возможного объединения, является стратегической национальной целью." },
      4: { text: "Улучшение отношений с Российской Федерацией важно для обеспечения региональной стабильности и экономических выгод, таких как более низкие цены на энергию." },
      5: { text: "В зависимости от выбранного внешнеполитического вектора кандидат должен находиться в хороших отношениях с соответствующими партнёрами и быть поддержан и принят ими." },
      6: { text: "В зависимости от выбранного внешнеполитического вектора кандидат должен понимать и уважать ценности и обязательства, продиктованные этим направлением." },
      7: { text: "Реформа судебной системы, включая внешнюю оценку (вейтинг) судей и прокуроров, должна быть ускорена для укрепления верховенства закона." },
      8: { text: "Борьба с крупной коррупцией, незаконным финансированием партий и дезинформацией должна стать абсолютным приоритетом." },
      9: { text: "Государство должно взять на себя более активную роль в экономике через масштабные социальные программы, субсидии и прямую помощь, даже если это приведёт к увеличению государственных расходов." },
      10: { text: "Государственные учреждения должны получить расширенные полномочия для борьбы с дезинформацией и подрывной деятельностью, финансируемой из-за рубежа." }
    }
  }
}

const scores = {
  questions: {
    1: {
      "options": {
        "1": {
          "pas": 2,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 1,
          "stamate": 1,
          "psde": 1,
          "pnm": 0,
          "bep": -2,
          "alternativa": -2,
          "mrm": 0,
          "impreuna": 1,
          "loc": 1,
          "aur": -2,
          "sanduta": 0,
          "am": 1,
          "bun": -2,
          "pl": -2,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        },
        "2": {
          "pas": 1,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 2,
          "stamate": 2,
          "psde": 2,
          "pnm": 0,
          "bep": -1,
          "alternativa": -1,
          "mrm": 0,
          "impreuna": 2,
          "loc": 2,
          "aur": -1,
          "sanduta": 0,
          "am": 2,
          "bun": -1,
          "pl": -1,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": -1,
          "stamate": -1,
          "psde": -1,
          "pnm": 0,
          "bep": 1,
          "alternativa": 1,
          "mrm": 0,
          "impreuna": -1,
          "loc": -1,
          "aur": 1,
          "sanduta": 0,
          "am": -1,
          "bun": 1,
          "pl": 1,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": -2,
          "stamate": -2,
          "psde": -2,
          "pnm": 0,
          "bep": 2,
          "alternativa": 2,
          "mrm": 0,
          "impreuna": -2,
          "loc": -2,
          "aur": 2,
          "sanduta": 0,
          "am": -2,
          "bun": 2,
          "pl": 2,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        }
      }
    },
    2: {
      "options": {
        "1": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": 0,
          "stamate": -2,
          "psde": -2,
          "pnm": -2,
          "bep": 2,
          "alternativa": 2,
          "mrm": 0,
          "impreuna": -2,
          "loc": 0,
          "aur": -2,
          "sanduta": 0,
          "am": -2,
          "bun": -2,
          "pl": -2,
          "ucsm": 2,
          "cretu": 0,
          "pn": 2
        },
        "2": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": 0,
          "stamate": -1,
          "psde": -1,
          "pnm": -1,
          "bep": 1,
          "alternativa": 1,
          "mrm": 0,
          "impreuna": -1,
          "loc": 0,
          "aur": -1,
          "sanduta": 0,
          "am": -1,
          "bun": -1,
          "pl": -1,
          "ucsm": 1,
          "cretu": 0,
          "pn": 1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": 1,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 0,
          "stamate": 1,
          "psde": 1,
          "pnm": 1,
          "bep": -1,
          "alternativa": -1,
          "mrm": 0,
          "impreuna": 1,
          "loc": 0,
          "aur": 1,
          "sanduta": 0,
          "am": 1,
          "bun": 1,
          "pl": 1,
          "ucsm": -1,
          "cretu": 0,
          "pn": -1
        },
        "5": {
          "pas": 2,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 0,
          "stamate": 2,
          "psde": 2,
          "pnm": 2,
          "bep": -2,
          "alternativa": -2,
          "mrm": 0,
          "impreuna": 2,
          "loc": 0,
          "aur": 2,
          "sanduta": 0,
          "am": 2,
          "bun": 2,
          "pl": 2,
          "ucsm": -2,
          "cretu": 0,
          "pn": -2
        }
      }
    },
    3: {
      "options": {
        "1": {
          "pas": 1,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 0,
          "stamate": 1,
          "psde": 1,
          "pnm": 1,
          "bep": -2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 1,
          "loc": 0,
          "aur": 2,
          "sanduta": 0,
          "am": -2,
          "bun": 2,
          "pl": 2,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        },
        "2": {
          "pas": 2,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 0,
          "stamate": 2,
          "psde": 2,
          "pnm": 2,
          "bep": -1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 2,
          "loc": 0,
          "aur": 1,
          "sanduta": 0,
          "am": -1,
          "bun": 1,
          "pl": 1,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": 0,
          "stamate": -1,
          "psde": -1,
          "pnm": -1,
          "bep": 1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": -1,
          "loc": 0,
          "aur": -1,
          "sanduta": 0,
          "am": 1,
          "bun": -1,
          "pl": -1,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": 0,
          "stamate": -2,
          "psde": -2,
          "pnm": -2,
          "bep": 2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": -2,
          "loc": 0,
          "aur": -2,
          "sanduta": 0,
          "am": 2,
          "bun": -2,
          "pl": -2,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        }
      }
    },
    4: {
      "options": {
        "1": {
          "pas": -2,
          "cub": -2,
          "psde": -2,
          "impreuna": -2,
          "pn": 2,
          "bep": 2,
          "aur": -2,
          "pl": -2,
          "bun": -2,
          "alternativa": 0,
          "mrm": 0,
          "am": 0,
          "ucsm": 0,
          "nastase": -2,
          "stamate": -2,
          "cretu": 2,
          "sanduta": -2,
          "loc": -2,
          "pnm": -2,
          "ppda": -2,
          "alde": -2
        },
        "2": {
          "pas": -1,
          "cub": -1,
          "psde": -1,
          "impreuna": -1,
          "pn": 1,
          "bep": 1,
          "aur": -1,
          "pl": -1,
          "bun": -1,
          "alternativa": 0,
          "mrm": 0,
          "am": 0,
          "ucsm": 0,
          "nastase": -1,
          "stamate": -1,
          "cretu": 1,
          "sanduta": -1,
          "loc": -1,
          "pnm": -1,
          "ppda": -1,
          "alde": -1
        },
        "3": {
          "pas": 0,
          "cub": 0,
          "psde": 0,
          "impreuna": 0,
          "pn": 0,
          "bep": 0,
          "aur": 0,
          "pl": 0,
          "bun": 0,
          "alternativa": 0,
          "mrm": 0,
          "am": 0,
          "ucsm": 0,
          "nastase": 0,
          "stamate": 0,
          "cretu": 0,
          "sanduta": 0,
          "loc": 0,
          "pnm": 0,
          "ppda": 0,
          "alde": 0
        },
        "4": {
          "pas": 1,
          "cub": 1,
          "psde": 1,
          "impreuna": 1,
          "pn": -1,
          "bep": -1,
          "aur": 2,
          "pl": 1,
          "bun": 1,
          "alternativa": 0,
          "mrm": 0,
          "am": 0,
          "ucsm": 0,
          "nastase": 2,
          "stamate": 2,
          "cretu": -1,
          "sanduta": 2,
          "loc": 2,
          "pnm": 1,
          "ppda": 1,
          "alde": 1
        },
        "5": {
          "pas": 2,
          "cub": 2,
          "psde": 2,
          "impreuna": 2,
          "pn": -2,
          "bep": -2,
          "aur": 1,
          "pl": 2,
          "bun": 2,
          "alternativa": 0,
          "mrm": 0,
          "am": 0,
          "ucsm": 0,
          "nastase": 1,
          "stamate": 1,
          "cretu": -2,
          "sanduta": 1,
          "loc": 1,
          "pnm": 2,
          "ppda": 2,
          "alde": 2
        }
      }
    },
    5: {
      "options": {
        "1": {
          "pas": 2,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 1,
          "stamate": 2,
          "psde": 2,
          "pnm": 0,
          "bep": 2,
          "alternativa": -2,
          "mrm": 1,
          "impreuna": 2,
          "loc": 1,
          "aur": 2,
          "sanduta": 0,
          "am": 0,
          "bun": 2,
          "pl": 2,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        },
        "2": {
          "pas": 1,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 2,
          "stamate": 1,
          "psde": 1,
          "pnm": 0,
          "bep": 1,
          "alternativa": -1,
          "mrm": 2,
          "impreuna": 1,
          "loc": 2,
          "aur": 1,
          "sanduta": 0,
          "am": 0,
          "bun": 1,
          "pl": 1,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": -1,
          "stamate": -1,
          "psde": -1,
          "pnm": 0,
          "bep": -1,
          "alternativa": 1,
          "mrm": -1,
          "impreuna": -1,
          "loc": -1,
          "aur": -1,
          "sanduta": 0,
          "am": 0,
          "bun": -1,
          "pl": -1,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": -2,
          "stamate": -2,
          "psde": -2,
          "pnm": 0,
          "bep": -2,
          "alternativa": 2,
          "mrm": -2,
          "impreuna": -2,
          "loc": -2,
          "aur": -2,
          "sanduta": 0,
          "am": 0,
          "bun": -2,
          "pl": -2,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        }
      }
    },
    6: {
      "options": {
        "1": {
          "pas": 2,
          "ppda": 1,
          "cub": 2,
          "nastase": 1,
          "alde": 2,
          "stamate": 2,
          "psde": 2,
          "pnm": 0,
          "bep": 2,
          "alternativa": -2,
          "mrm": 0,
          "impreuna": 1,
          "loc": 0,
          "aur": 2,
          "sanduta": 0,
          "am": 0,
          "bun": 2,
          "pl": 2,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        },
        "2": {
          "pas": 1,
          "ppda": 2,
          "cub": 1,
          "nastase": 2,
          "alde": 1,
          "stamate": 1,
          "psde": 1,
          "pnm": 0,
          "bep": 1,
          "alternativa": -1,
          "mrm": 0,
          "impreuna": 2,
          "loc": 0,
          "aur": 1,
          "sanduta": 0,
          "am": 0,
          "bun": 1,
          "pl": 1,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": -1,
          "stamate": -1,
          "psde": -1,
          "pnm": 0,
          "bep": -1,
          "alternativa": 1,
          "mrm": 0,
          "impreuna": -1,
          "loc": 0,
          "aur": -1,
          "sanduta": 0,
          "am": 0,
          "bun": -1,
          "pl": -1,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": -2,
          "stamate": -2,
          "psde": -2,
          "pnm": 0,
          "bep": -2,
          "alternativa": 2,
          "mrm": 0,
          "impreuna": -2,
          "loc": 0,
          "aur": -2,
          "sanduta": 0,
          "am": 0,
          "bun": -2,
          "pl": -2,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        }
      }
    },
    7: {
      "options": {
        "1": {
          "pas": 2,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 0,
          "stamate": 2,
          "psde": 1,
          "pnm": 1,
          "bep": -2,
          "alternativa": -2,
          "mrm": 0,
          "impreuna": 1,
          "loc": 0,
          "aur": 1,
          "sanduta": 1,
          "am": 0,
          "bun": 0,
          "pl": 1,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        },
        "2": {
          "pas": 1,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 0,
          "stamate": 1,
          "psde": 2,
          "pnm": 2,
          "bep": -1,
          "alternativa": -1,
          "mrm": 0,
          "impreuna": 2,
          "loc": 0,
          "aur": 2,
          "sanduta": 2,
          "am": 0,
          "bun": 0,
          "pl": 2,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": 0,
          "stamate": -1,
          "psde": -1,
          "pnm": -1,
          "bep": 1,
          "alternativa": 1,
          "mrm": 0,
          "impreuna": -1,
          "loc": 0,
          "aur": -1,
          "sanduta": -1,
          "am": 0,
          "bun": 0,
          "pl": -1,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": 0,
          "stamate": -2,
          "psde": -2,
          "pnm": -2,
          "bep": 2,
          "alternativa": 2,
          "mrm": 0,
          "impreuna": -2,
          "loc": 0,
          "aur": -2,
          "sanduta": -2,
          "am": 0,
          "bun": 0,
          "pl": -2,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        }
      }
    },
    8: {
      "options": {
        "1": {
          "pas": 2,
          "ppda": 2,
          "cub": 0,
          "nastase": 2,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": -2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "2": {
          "pas": 1,
          "ppda": 1,
          "cub": 0,
          "nastase": 1,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": -1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": 0,
          "nastase": -1,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": 0,
          "nastase": -2,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        }
      }
    },
    9: {
      "options": {
        "1": {
          "pas": 1,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 0,
          "stamate": 1,
          "psde": 2,
          "pnm": 0,
          "bep": 2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 1,
          "loc": 0,
          "aur": -2,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        },
        "2": {
          "pas": 2,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 0,
          "stamate": 2,
          "psde": 1,
          "pnm": 0,
          "bep": 1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 2,
          "loc": 0,
          "aur": -1,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": 0,
          "stamate": -1,
          "psde": -1,
          "pnm": 0,
          "bep": -1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": -1,
          "loc": 0,
          "aur": 1,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": 0,
          "stamate": -2,
          "psde": -2,
          "pnm": 0,
          "bep": -2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": -2,
          "loc": 0,
          "aur": 2,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        }
      }
    },
    10: {
      "options": {
        "1": {
          "pas": 2,
          "ppda": 1,
          "cub": 1,
          "nastase": 1,
          "alde": 1,
          "stamate": 2,
          "psde": 1,
          "pnm": 1,
          "bep": -2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 1,
          "loc": -2,
          "aur": -2,
          "sanduta": -2,
          "am": 0,
          "bun": 0,
          "pl": 1,
          "ucsm": 0,
          "cretu": 0,
          "pn": -2
        },
        "2": {
          "pas": 1,
          "ppda": 2,
          "cub": 2,
          "nastase": 2,
          "alde": 2,
          "stamate": 1,
          "psde": 2,
          "pnm": 2,
          "bep": -1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 2,
          "loc": -1,
          "aur": -1,
          "sanduta": -1,
          "am": 0,
          "bun": 0,
          "pl": 2,
          "ucsm": 0,
          "cretu": 0,
          "pn": -1
        },
        "3": {
          "pas": 0,
          "ppda": 0,
          "cub": 0,
          "nastase": 0,
          "alde": 0,
          "stamate": 0,
          "psde": 0,
          "pnm": 0,
          "bep": 0,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": 0,
          "loc": 0,
          "aur": 0,
          "sanduta": 0,
          "am": 0,
          "bun": 0,
          "pl": 0,
          "ucsm": 0,
          "cretu": 0,
          "pn": 0
        },
        "4": {
          "pas": -1,
          "ppda": -1,
          "cub": -1,
          "nastase": -1,
          "alde": -1,
          "stamate": -1,
          "psde": -1,
          "pnm": -1,
          "bep": 1,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": -1,
          "loc": 2,
          "aur": 1,
          "sanduta": 2,
          "am": 0,
          "bun": 0,
          "pl": -1,
          "ucsm": 0,
          "cretu": 0,
          "pn": 2
        },
        "5": {
          "pas": -2,
          "ppda": -2,
          "cub": -2,
          "nastase": -2,
          "alde": -2,
          "stamate": -2,
          "psde": -2,
          "pnm": -2,
          "bep": 2,
          "alternativa": 0,
          "mrm": 0,
          "impreuna": -2,
          "loc": 1,
          "aur": 2,
          "sanduta": 1,
          "am": 0,
          "bun": 0,
          "pl": -2,
          "ucsm": 0,
          "cretu": 0,
          "pn": 1
        }
      }
    }
  }
}

const deepMergeAll = (...objects) => {
  const result = {};

  for (const obj of objects) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key]) && typeof result[key] === 'object' && result[key] !== null) {
          result[key] = deepMergeAll(result[key], obj[key]);
        } else {
          result[key] = obj[key];
        }
      }
    }
  }

  return result;
};

const roQuestionsWithScores = deepMergeAll(roQuestions, { ro: scores });
const ruQuestionsWithScores = deepMergeAll(ruQuestions, { ru: scores });

export default deepMergeAll(elements, parties, roQuestionsWithScores, ruQuestionsWithScores, options);